import React, { useState, useEffect } from 'react';
import AntTable from 'common_components/AntTable';
import { Tooltip } from 'antd';
import { dateTimeTimestamptzFormatter } from 'common_components/AntTable/tableUtils';
import styled from 'styled-components';
import useWindowSize from 'hooks/windowSize';
import moment from 'moment-timezone';
import './index.css';
const TableComponent = (props) => {
  const { rowData, isLoading } = props;
  const { height } = useWindowSize();
  const [tableHeight, setTableHeight] = useState(0);

  const columns = [
    {
      title: 'Job code',
      dataIndex: 'job_code',
      align: 'center',
      width: 80,
      className: 'bg-grey',
      render: (text, record) => {
        if (record.job_code_new) {
          const hasChanged = record.job_code_new !== text;
          return (
            <Tooltip placement='bottom' title={text}>
              <div
                style={{
                  color: hasChanged ? '#ff0000' : 'initial',
                }}
              >
                {record.job_code_new}
              </div>
            </Tooltip>
          );
        } else {
          return text;
        }
      },
    },
    {
      title: 'Trip no.',
      dataIndex: 'trip_no',
      align: 'center',
      width: 70,
      className: 'bg-grey',
      render: (text, record) => {
        if (record.trip_no_new !== undefined) {
          const hasChanged = text !== record.trip_no_new;
          return (
            <Tooltip placement='bottom' title={text}>
              <div
                style={{
                  color: hasChanged ? '#ff0000' : 'initial',
                }}
              >
                {record.trip_no_new}
              </div>
            </Tooltip>
          );
        } else {
          return text;
        }
      },
    },
    {
      title: 'Combine Code',
      dataIndex: 'combine',
      width: 100,
      align: 'center',
      ellipsis: true,
      className: 'bg-grey',
      render: (text, record) => {
        const originalCombine = record?.combine_before || '';
        const newCombine = text || '';
        const hasChanged = newCombine !== originalCombine;

        if (hasChanged) {
          return (
            <Tooltip placement='bottom' title={originalCombine}>
              <div
                style={{
                  color: '#ff0000',
                }}
              >
                {newCombine}
              </div>
            </Tooltip>
          );
        } else {
          return text;
        }
      },
    },

    {
      title: 'From',
      dataIndex: ['actual_from', 'short_name'],
      width: 250,
      align: 'center',
      render: (text, record) => {
        if (text) {
          if (record.actual_from_edit) {
            const originalFrom = record.actual_from_before || '';
            const newFrom = record.actual_from_edit?.label || '';
            const hasChanged = newFrom !== originalFrom && newFrom !== text;

            return (
              <Tooltip placement='bottom' title={text}>
                <div
                  style={{
                    color: hasChanged ? '#ff0000' : 'initial',
                  }}
                >
                  {newFrom}
                </div>
              </Tooltip>
            );
          } else {
            return text;
          }
        } else {
          return null;
        }
      },
    },

    {
      title: 'Destination',
      dataIndex: ['actual_cluster_to', 'name'],
      width: 120,
      align: 'center',
      ellipsis: true,
      render: (text, record) => {
        if (record.actual_destination_edit) {
          const originalDestName = record.actual_cluster_to_before?.name || '';
          const newDestName = record.actual_destination_edit?.cluster?.name || '';
          const hasChanged = newDestName !== originalDestName && newDestName !== text;

          return (
            <Tooltip placement='bottom' title={text || ''}>
              <div
                style={{
                  color: hasChanged ? '#ff0000' : 'initial',
                }}
              >
                {newDestName || text || ''}
              </div>
            </Tooltip>
          );
        } else {
          return text;
        }
      },
    },
    {
      title: 'Return Place',
      dataIndex: 'actual_return_place_before',
      width: 100,
      align: 'center',
      ellipsis: true,
      className: 'bg-grey',
      render: (text, record) => {
        const originalReturnPlace = text || '';
        const newReturnPlace = record.actual_return_place || '';
        const hasChanged = originalReturnPlace !== newReturnPlace;

        if (hasChanged) {
          return (
            <Tooltip placement='bottom' title={originalReturnPlace} >
              <div
                style={{
                  color: '#ff0000',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  width: '100%'
                }}
              >
                {newReturnPlace || originalReturnPlace}
              </div>
            </Tooltip>
          );
        } else {
          return text;
        }
      },
    },

    {
      title: 'Trailer type',
      dataIndex: ['trailer_type', 'name'],
      width: 120,
      align: 'center',
      ellipsis: true,
      className: 'bg-grey',

      render: (text, record) => {
        if (text) {
          if (record.trailer_type_edit) {
            const originalTrailerType = text || '';
            const newTrailerType = record.trailer_type_edit?.name || '';
            const hasChanged = newTrailerType !== originalTrailerType;

            return (
              <Tooltip placement='bottom' title={originalTrailerType}>
                <div
                  style={{
                    color: hasChanged ? '#ff0000' : 'initial',
                  }}
                >
                  {newTrailerType}
                </div>
              </Tooltip>
            );
          } else {
            return text;
          }
        } else {
          return null;
        }
      },
    },
    {
      title: 'Calling no.',
      dataIndex: ['callingsheet', 'callingsheet_no'],
      width: 130,
      align: 'center',
      ellipsis: true,
      className: 'bg-grey',
    },
    {
      title: 'Trip Type',
      dataIndex: ['trip_type', 'name_en'],
      width: 120,
      align: 'center',
      ellipsis: true,
      render: (text, record) => {
        if (text) {
          if (record.trip_type_edit) {
            const originalTripType = text || '';
            const newTripType = record.trip_type_edit?.label || '';
            const hasChanged = newTripType !== originalTripType;

            return (
              <Tooltip placement='bottom' title={originalTripType}>
                <div
                  style={{
                    color: hasChanged ? '#ff0000' : 'initial',
                  }}
                >
                  {newTripType}
                </div>
              </Tooltip>
            );
          } else {
            return text;
          }
        } else {
          return null;
        }
      },
    },
    {
      title: 'Trailer code',
      dataIndex: ['trailers', 0, 'trailer_card_id'],
      width: 150,
      align: 'center',
      ellipsis: true,
      render: (text, record) => {
        if (text || record.trailersNew) {
          if (record.trailersNew) {
            const originalTrailerCode = text || '';
            const newTrailerCode = record.trailersNew?.label || '';
            const hasChanged = newTrailerCode !== originalTrailerCode;

            return (
              <Tooltip placement='bottom' title={originalTrailerCode}>
                <div
                  style={{
                    color: hasChanged ? '#ff0000' : 'initial',
                  }}
                >
                  {newTrailerCode}
                </div>
              </Tooltip>
            );
          } else {
            return text;
          }
        } else {
          return null;
        }
      },
    },
    {
      title: 'Driver code 1',
      dataIndex: ['drivers', 0, 'tlep_code'],
      width: 150,
      align: 'center',
      ellipsis: true,
      render: (text, record) => {
        if (text || (record.driversCode1 && record.driversCode1New)) {
          if (record.driversCode1 && record.driversCode1New) {
            const originalDriverCode = text || '';
            const newDriverCode = record.driversCode1?.label || '';
            const hasChanged = newDriverCode !== originalDriverCode;

            return (
              <Tooltip placement='bottom' title={originalDriverCode}>
                <div
                  style={{
                    color: hasChanged ? '#ff0000' : 'initial',
                  }}
                >
                  {newDriverCode}
                </div>
              </Tooltip>
            );
          } else {
            return text;
          }
        } else {
          return null;
        }
      },
    },
    {
      title: 'Driver code 2',
      dataIndex: ['drivers', 1, 'tlep_code'],
      width: 150,
      align: 'center',
      ellipsis: true,
      render: (text, record) => {
        if (text || (record.driversCode2 && record.driversCode2New)) {
          if (record.driversCode2 && record.driversCode2New) {
            const originalDriverCode = text || '';
            const newDriverCode = record.driversCode2?.label || '';
            const hasChanged = newDriverCode !== originalDriverCode;

            return (
              <Tooltip placement='bottom' title={originalDriverCode}>
                <div
                  style={{
                    color: hasChanged ? '#ff0000' : 'initial',
                  }}
                >
                  {newDriverCode}
                </div>
              </Tooltip>
            );
          } else {
            return text;
          }
        } else {
          return null;
        }
      },
    },

    {
      title: 'Receive Job Time',
      dataIndex: 'actual_receive_job_datetime_before',
      width: 145,
      align: 'center',
      render: (text, record) => {
        if (text || record.actual_receive_job_datetime_edit) {
          if (text && record.actual_receive_job_datetime_edit === null) {
            return (
              <div
                style={{
                  color: '#ff0000',
                }}
              >
                {'-'}
              </div>
            );
          } else if (record.actual_receive_job_datetime_edit) {
            const formattedOriginalTime = text
              ? dateTimeTimestamptzFormatter({ value: text })
              : '';
            const formattedNewTime = dateTimeTimestamptzFormatter({
              value: record.actual_receive_job_datetime_edit,
            });
            const hasChanged = formattedOriginalTime !== formattedNewTime;

            return (
              <Tooltip placement='bottom' title={formattedOriginalTime}>
                <div
                  style={{
                    color: hasChanged ? '#ff0000' : 'initial',
                  }}
                >
                  {formattedNewTime}
                </div>
              </Tooltip>
            );
          } else {
            return dateTimeTimestamptzFormatter({
              value: text,
            });
          }
        } else {
          return <div>{'-'}</div>;
        }
      },
    },
    {
      title: 'Yard out time',
      dataIndex: 'actual_yardout_datetime_before',
      width: 145,
      align: 'center',
      ellipsis: true,
      render: (text, record) => {
        if (text || record.actual_yardout_datetime_edit) {
          if (text && record.actual_yardout_datetime_edit === null) {
            return (
              <div
                style={{
                  color: '#ff0000',
                }}
              >
                {'-'}
              </div>
            );
          } else if (record.actual_yardout_datetime_edit) {
            const formattedOriginalTime = text
              ? dateTimeTimestamptzFormatter({ value: text })
              : '';
            const formattedNewTime = dateTimeTimestamptzFormatter({
              value: record.actual_yardout_datetime_edit,
            });
            const hasChanged = formattedOriginalTime !== formattedNewTime;

            return (
              <Tooltip placement='bottom' title={formattedOriginalTime}>
                <div
                  style={{
                    color: hasChanged ? '#ff0000' : 'initial',
                  }}
                >
                  {formattedNewTime}
                </div>
              </Tooltip>
            );
          } else {
            return dateTimeTimestamptzFormatter({
              value: text,
            });
          }
        } else {
          return <div>{'-'}</div>;
        }
      },
    },
    {
      title: 'Arrival time',
      dataIndex: 'actual_arrival_time_before',
      width: 145,
      align: 'center',
      ellipsis: true,
      render: (text, record) => {
        if (text || record.actual_arrival_time_max_date) {
          if (text && record.actual_arrival_time_max_date === null) {
            return (
              <div
                style={{
                  color: '#ff0000',
                }}
              >
                {'-'}
              </div>
            );
          } else if (record.actual_arrival_time_max_date) {
            const originalMoment = text ? moment(text) : null;
            const newMoment = record.actual_arrival_time_max_date;
            const hasChanged =
              !originalMoment || (newMoment && !newMoment.isSame(originalMoment));

            return (
              <Tooltip
                placement='bottom'
                title={text ? dateTimeTimestamptzFormatter({ value: text }) : ''}
              >
                <div
                  style={{
                    color: hasChanged ? '#ff0000' : 'initial',
                  }}
                >
                  {dateTimeTimestamptzFormatter({
                    value: record.actual_arrival_time_max_date,
                  })}
                </div>
              </Tooltip>
            );
          } else {
            return dateTimeTimestamptzFormatter({
              value: text,
            });
          }
        } else {
          return <div>{'-'}</div>;
        }
      },
    },

    {
      title: 'Last update',
      dataIndex: 'updated_at',
      width: 140,
      align: 'center',
      ellipsis: true,
      className: 'bg-grey',
      render: (text) => {
        return dateTimeTimestamptzFormatter({ value: text });
      },
    },
    {
      title: 'Updater',
      dataIndex: ['updated_by', 'fullname_en'],
      width: 170,
      align: 'center',
      ellipsis: true,
      className: 'bg-grey',
    },
  ];

  useEffect(() => {
    if (height) {
      let h = height - 420;
      if (h % 2 !== 0) {
        h = h - 1;
      }
      setTableHeight(h);
    }
  }, [height]);

  return (
    <Container>
      <StyledTable
        rowKey='id'
        tableId={'newStatusChange'}
        className={'statusChange'}
        rowSelection={{
          hideSelectAll: true,
          getCheckboxProps: () => {
            return {
              disabled: true,
            };
          },
        }}
        loading={isLoading}
        bordered
        showSorterTooltip={false}
        columns={columns}
        dataSource={rowData}
        pagination={false}
        height={tableHeight}
        scroll={{
          y: tableHeight,
          x: 'max-content',
        }}
      />
    </Container>
  );
};
const Container = styled.div`
  padding: 0 10px;
`;

const StyledTable = styled(AntTable)`
  &&& {
    .ant-table > .ant-table-container > .ant-table-body tr td {
      // padding: 3px;
      font-size: 14px;
    }
    .disabled-row {
      background-color: #000;
    }
  }
`;

export default TableComponent;
